<template>
  <div class="login-page3">
    <span class="back-site">FA</span>

    <div class="hero">
      <div class="hero-inner">
        <div class="logo-wrap">
          <img :src="`${publicPath}img/sinaweb.png`" alt="loptop background" class="plane" />
        </div>

        <div class="hero-text">
          <h1>سیستم‌های راهبردی؛ <br />پاسخ‌گوی نیازهای امروز سازمان‌ها</h1>
          <BaseButton title="اطلاعات بیشتر" variant="primary" type="button" />
        </div>
      </div>
    </div>

    <div class="auth-card">
      <div class="card-inner">
        <!-- <h3 class="card-title">ورود/ثبت نام</h3> -->
        <div class="card-tabs">
          <BaseButton title="ورود" :variant="activeTab === 'login' ? 'primary' : 'ghost'" type="button"
            @click="switchTab('login')" />
          <BaseButton title="ثبت نام" :variant="activeTab === 'register' ? 'primary' : 'ghost'" type="button"
            @click="switchTab('register')" />
        </div>

        <!-- LOGIN / REGISTER (animated) -->
        <transition name="tab" mode="out-in">
          <div v-if="activeTab === 'login'" key="login">
            <!-- STEP 1: identifier input (email or phone) -->
            <div v-if="step === 1" class="otp-step">
              <transition name="forgot-flow" mode="out-in">
                <div v-if="!forgotPasswordMode" key="login-default">
                  <input v-model="identifier" :disabled="loadingSend" @keyup.enter="handleSend" class="input"
                    :placeholder="identifierPlaceholder" ref="identifierInput" autocomplete="username" type="text" />

                  <!-- Password Field -->
                  <input v-model="password" :disabled="loadingSend" @keyup.enter="handleSend"
                    class="input password-input" placeholder="رمز عبور" ref="passwordInput"
                    autocomplete="current-password" type="password" />

                  <!-- Turnstile widget placeholder (invisible). Rendered programmatically to keep UX clean -->
                  <!-- CAPTCHA disabled: <div ref="turnstileEl" style="display:none" aria-hidden="true"></div> -->

                  <BaseButton :title="loadingSend ? 'در حال ارسال…' : 'ورود'" variant="primary" size="lg" type="button"
                    :style="{ width: '100%', marginTop: '18px', fontSize: '22px' }"
                    :disabled="loadingSend || sendingDisabled" @click="handleSend" />

                  <div class="center-btn">
                    <BaseButton title="فراموشی رمز عبور" variant="ghost" type="button"
                      @click="enterForgotPasswordMode" />
                  </div>
                  <p class="error" v-if="error">{{ error }}</p>
                  <div class="divider">یا</div>

                  <div class="center-btn">
                    <BaseButton :title="''" variant="outline" type="button"
                      :style="{ padding: '8px', minWidth: '40px', minHeight: '40px', lineHeight: '0' }"
                      :disabled="googleLoading" @click="onGoogle">
                      <template #icon>
                        <img :src="`${publicPath}img/google.svg`" alt="Google" class="g-icon" aria-hidden="true" />
                      </template>
                    </BaseButton>
                  </div>

                  <p class="terms">ورود به معنای پذیرش
                    <a href="https://www.sinapardazesh.ir/terms-of-service" target="_blank" rel="noopener noreferrer"
                      title="شرایط استفاده">شرایط استفاده</a>
                    و
                    <a href="https://www.sinapardazesh.ir/privacy-policy" target="_blank" rel="noopener noreferrer"
                      title="سیاست حفظ حریم خصوصی">سیاست حفظ حریم خصوصی</a>
                    است
                  </p>
                </div>

                <div v-else key="forgot-password">
                  <transition name="forgot-step" mode="out-in">
                    <div v-if="forgotPasswordStep === 1" key="forgot-identifier">
                      <input v-model="forgotPasswordIdentifier" :disabled="loadingSend"
                        @keyup.enter="handleForgotPasswordSendCode" class="input"
                        placeholder="شماره موبایل یا نام کاربری" ref="identifierInput" autocomplete="username"
                        type="text" />
                      <p class="links">جهت بازیابی رمز عبور لطفا شماره موبایل یا نام کاربری خود را وارد نمایید.</p>

                      <div class="forgot-actions">
                        <BaseButton title="ارسال کد بازیابی رمز" variant="primary" type="button"
                          :style="{ width: '100%' }" :disabled="loadingSend || !forgotPasswordIdentifier.trim()"
                          @click="handleForgotPasswordSendCode" />
                        <BaseButton title="بازگشت به صفحه ورود" variant="secondary" type="button"
                          :style="{ width: '100%' }" @click="backToLoginFromForgot" />
                      </div>
                    </div>

                    <div v-else-if="forgotPasswordStep === 2" key="forgot-code">
                      <input v-model="forgotPasswordCode" ref="codeInput" class="input" inputmode="numeric"
                        pattern="\d{6}" maxlength="6" autocomplete="one-time-code" :disabled="loadingVerify"
                        @keyup.enter="handleForgotPasswordVerify" @input="handleForgotPasswordCodeInput"
                        placeholder="رمز 6 رقمی" type="text" />

                      <BaseButton :title="loadingVerify ? 'در حال ثبت…' : 'ثبت'" variant="primary" type="button"
                        :style="{ width: '100%', marginTop: '18px', fontSize: '22px' }"
                        :disabled="loadingVerify || forgotPasswordCode.length !== 6"
                        @click="handleForgotPasswordVerify" />
                    </div>

                    <div v-else key="forgot-reset-password" class="forgot-reset-step">
                      <h3 class="forgot-reset-title">تنظیم رمز عبور جدید</h3>
                      <p class="forgot-reset-text">کاربر گرامی، لطفا رمز عبور جدید خود را وارد نمایید.</p>

                      <input v-model="forgotPasswordNewPassword" ref="forgotPasswordNewPasswordInput" class="input"
                        :disabled="forgotPasswordSubmitting" @keyup.enter="handleForgotPasswordSetNewPassword"
                        autocomplete="new-password" placeholder="رمز عبور جدید" type="password" />

                      <input v-model="forgotPasswordConfirmNewPassword" class="input password-input"
                        :disabled="forgotPasswordSubmitting" @keyup.enter="handleForgotPasswordSetNewPassword"
                        autocomplete="new-password" placeholder="تکرار رمز عبور جدید" type="password" />

                      <BaseButton :title="forgotPasswordSubmitting ? 'در حال ثبت...' : 'ثبت'" variant="primary"
                        type="button" :style="{ width: '100%', marginTop: '18px', fontSize: '22px' }"
                        :disabled="forgotPasswordSubmitting" @click="handleForgotPasswordSetNewPassword" />
                    </div>
                  </transition>

                  <p class="error" v-if="error">{{ error }}</p>
                </div>
              </transition>
            </div>

            <!-- STEP 2: OTP code input -->
            <div v-else class="otp-step">
              <label class="field-label">کد تایید</label>
              <input v-model="code" ref="codeInput" class="input" inputmode="numeric" pattern="\d{6}" maxlength="6"
                autocomplete="one-time-code" :disabled="loadingVerify || expired" @keyup.enter="handleVerify"
                @input="handleOtpInput" placeholder="کد 6 رقمی" type="text" />

              <div class="otp-meta">
                <div class="timer" :class="{ 'timer-warning': remaining < 60 }">{{ timerLabel }}</div>
                <BaseButton title="ارسال دوباره کد" variant="ghost" type="button"
                  :disabled="resendDisabled || loadingSend" @click="resendOtp" />
              </div>

              <div class="otp-actions">
                <BaseButton :title="loadingVerify ? 'در حال بررسی…' : 'تایید و ورود'" variant="primary" type="button"
                  :style="{ width: '100%' }" :disabled="loadingVerify || expired" @click="handleVerify" />
              </div>

              <!-- secondary gray button under the confirm button to change identifier -->
              <div class="otp-secondary">
                <BaseButton title="تغییر شماره/ایمیل" variant="secondary" type="button" :disabled="loadingVerify"
                  @click.prevent="backToStep1" />
              </div>

              <p class="error" v-if="error">{{ error }}</p>

              <div class="divider">یا</div>

              <div class="center-btn">
                <BaseButton :title="''" variant="outline" type="button"
                  :style="{ padding: '8px', minWidth: '40px', minHeight: '40px', lineHeight: '0' }"
                  :disabled="googleLoading" @click="onGoogle">
                  <template #icon>
                    <img :src="`${publicPath}img/google.svg`" alt="Google" class="g-icon" aria-hidden="true" />
                  </template>
                </BaseButton>
              </div>

              <p class="terms">ورود به معنای پذیرش
                <a href="https://www.sinapardazesh.ir/terms-of-service" target="_blank" rel="noopener noreferrer"
                  title="شرایط استفاده">شرایط استفاده</a>
                و
                <a href="https://www.sinapardazesh.ir/privacy-policy" target="_blank" rel="noopener noreferrer"
                  title="سیاست حفظ حریم خصوصی">سیاست حفظ حریم خصوصی</a>
                است
              </p>
            </div>
          </div>

          <!-- REGISTER TAB -->
          <div v-else key="register" class="register-step">
            <!-- STEP 1: شماره موبایل -->
            <div v-if="registerStep === 1">
              <input v-model="registerPhone" :disabled="registerLoading" @keyup.enter="handleRegister" class="input"
                placeholder="شماره موبایل" ref="registerInput" type="text" />
              <p class="links">جهت ثبت نام لطفا شماره موبایل خود را وارد نمایید.</p>
              <BaseButton :title="registerLoading ? 'در حال ارسال…' : 'ثبت نام'" variant="primary" size="lg"
                type="button" :style="{ width: '100%', marginTop: '18px', fontSize: '22px' }"
                :disabled="registerLoading || !registerPhone.trim()" @click="handleRegister" />
              <p class="error" v-if="registerError">{{ registerError }}</p>
            </div>

            <!-- STEP 2: کد تایید -->
            <div v-else class="otp-step">
              <label class="field-label">کد تایید</label>
              <input v-model="registerCode" ref="registerCodeInput" class="input" inputmode="numeric" pattern="\d{6}"
                maxlength="6" autocomplete="one-time-code" :disabled="registerVerifyLoading || registerExpired"
                @keyup.enter="handleRegisterVerify" @input="handleRegisterOtpInput" placeholder="کد 6 رقمی"
                type="text" />

              <div class="otp-meta">
                <div class="timer" :class="{ 'timer-warning': registerRemaining < 60 }">{{ registerTimerLabel }}</div>
                <BaseButton title="ارسال دوباره کد" variant="ghost" type="button"
                  :disabled="registerResendDisabled || registerLoading" @click="resendRegisterOtp" />
              </div>

              <div class="otp-actions">
                <BaseButton :title="registerVerifyLoading ? 'در حال بررسی…' : 'تایید و ثبت نام'" variant="primary"
                  type="button" :disabled="registerVerifyLoading || registerExpired" @click="handleRegisterVerify" />
              </div>

              <div class="otp-secondary">
                <BaseButton title="تغییر شماره" variant="secondary" type="button" :disabled="registerVerifyLoading"
                  @click.prevent="backToRegisterStep1" />
              </div>

              <p class="error" v-if="registerError">{{ registerError }}</p>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>

  <!-- reuse the global footer (same as Overview/SoftwareLayout) -->
  <FooterLicense />
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, nextTick, watch } from 'vue'
import FooterLicense from '@/components/FooterLicense.vue'
import BaseButton from '@/components/UiCompunents/BaseButton.vue'
import apiClient from '@/axios'
import axios from 'axios'
import router from '@/router'
import { useSettingStore } from '@/stores/clinic/setting.js'
import { useToast } from 'vue-toastification'
import { useAuthenticateStore } from '@/stores/common/authenticate'

const authenticate = useAuthenticateStore();

// site key support for both vite and vue-cli env styles
const SITE_KEY = (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_TURNSTILE_SITE_KEY)
  || process.env.VUE_APP_TURNSTILE_SITE_KEY

const publicPath = (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.BASE_URL) || process.env.BASE_URL || '/'

// Toggle captcha (Cloudflare Turnstile) during development
// set to false to disable/skip captcha checks
const CAPTCHA_ENABLED = false

// store & utilities used for post-login setup
const settingStore = useSettingStore()
const { fetchSetting } = settingStore
const toast = useToast()

// reactive state
const step = ref(1)
const identifier = ref('')
const password = ref('')
const code = ref('')
const loadingSend = ref(false)
const loadingVerify = ref(false)
const googleLoading = ref(false)
const error = ref('')
const forgotPasswordMode = ref(false)
const forgotPasswordStep = ref(1)
const forgotPasswordIdentifier = ref('')
const forgotPasswordCode = ref('')
const forgotPasswordNewPassword = ref('')
const forgotPasswordConfirmNewPassword = ref('')
const forgotPasswordSubmitting = ref(false)

// tabs & register state
const activeTab = ref('login')
const registerStep = ref(1)
const registerPhone = ref('')
const registerCode = ref('')
const registerLoading = ref(false)
const registerVerifyLoading = ref(false)
const registerError = ref('')
const registerSuccess = ref('')
const registerExpiryTimestamp = ref(null)
const registerNow = ref(Date.now())
const registerResendAvailableAt = ref(null)
let registerTimerInterval = null

const expiryTimestamp = ref(null)
const now = ref(Date.now())
const resendAvailableAt = ref(null)
let timerInterval = null

const turnstileWidgetId = ref(null)
const turnstileToken = ref('')
const turnstileTokenExpiry = ref(0)
const awaitingTurnstile = ref(false)
let turnstileTimeoutId = null
let googleWindow = null
let googleInterval = null
let _onGoogleMessage = null

// DOM refs
const identifierInput = ref(null)
const passwordInput = ref(null)
const codeInput = ref(null)
const forgotPasswordNewPasswordInput = ref(null)
const turnstileEl = ref(null)
const registerInput = ref(null)
const registerCodeInput = ref(null)

const identifierPlaceholder = 'شماره موبایل یا نام کاربری'

const remaining = computed(() => {
  if (!expiryTimestamp.value) return 0
  return Math.max(0, Math.floor((expiryTimestamp.value - now.value) / 1000))
})

const timerLabel = computed(() => {
  const s = remaining.value
  const mm = String(Math.floor(s / 60)).padStart(2, '0')
  const ss = String(s % 60).padStart(2, '0')
  if (expired.value) return 'کد منقضی شده است'
  return `${mm}:${ss} مانده تا پایان اعتبار کد`
})

const expired = computed(() => remaining.value <= 0)

const resendDisabled = computed(() => {
  if (!resendAvailableAt.value) return true
  if (expired.value) return false
  return Date.now() < resendAvailableAt.value
})

const sendingDisabled = computed(() => identifier.value.trim().length === 0)

// Register computed properties
const registerRemaining = computed(() => {
  if (!registerExpiryTimestamp.value) return 0
  return Math.max(0, Math.floor((registerExpiryTimestamp.value - registerNow.value) / 1000))
})

const registerTimerLabel = computed(() => {
  const s = registerRemaining.value
  const mm = String(Math.floor(s / 60)).padStart(2, '0')
  const ss = String(s % 60).padStart(2, '0')
  if (registerExpired.value) return 'کد منقضی شده است'
  return `${mm}:${ss} مانده تا پایان اعتبار کد`
})

const registerExpired = computed(() => registerRemaining.value <= 0)

const registerResendDisabled = computed(() => {
  if (!registerResendAvailableAt.value) return true
  if (registerExpired.value) return false
  return Date.now() < registerResendAvailableAt.value
})

function validateIdentifier(id) {
  const value = (id || '').trim()
  if (!value) return { ok: false, message: 'لطفاً ایمیل یا شماره موبایل را وارد کنید.' }
  const emailRE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  const phoneRE = /^\+?\d{9,15}$/
  if (emailRE.test(value)) return { ok: true, type: 'email' }
  if (phoneRE.test(value)) return { ok: true, type: 'phone' }
  return { ok: false, message: 'فرمت وارد شده معتبر نیست. ایمیل یا شماره موبایل را بررسی کنید.' }
}

function switchTab(name) {
  activeTab.value = name
  // reset errors and context when switching
  error.value = ''
  forgotPasswordMode.value = false
  forgotPasswordStep.value = 1
  forgotPasswordIdentifier.value = ''
  forgotPasswordCode.value = ''
  forgotPasswordNewPassword.value = ''
  forgotPasswordConfirmNewPassword.value = ''
  forgotPasswordSubmitting.value = false
  registerError.value = ''
  registerSuccess.value = ''
  registerStep.value = 1
  registerCode.value = ''
  clearRegisterTimer()
  if (name === 'login') {
    nextTick(() => { if (identifierInput.value) identifierInput.value.focus() })
  } else {
    nextTick(() => { if (registerInput.value) registerInput.value.focus() })
  }
}

function enterForgotPasswordMode() {
  error.value = ''
  forgotPasswordMode.value = true
  forgotPasswordStep.value = 1
  forgotPasswordIdentifier.value = identifier.value.trim()
  forgotPasswordCode.value = ''
  forgotPasswordNewPassword.value = ''
  forgotPasswordConfirmNewPassword.value = ''
  forgotPasswordSubmitting.value = false
  nextTick(() => { if (identifierInput.value) identifierInput.value.focus() })
}

function backToLoginFromForgot() {
  error.value = ''
  forgotPasswordMode.value = false
  forgotPasswordStep.value = 1
  forgotPasswordIdentifier.value = ''
  forgotPasswordCode.value = ''
  forgotPasswordNewPassword.value = ''
  forgotPasswordConfirmNewPassword.value = ''
  forgotPasswordSubmitting.value = false
  nextTick(() => { if (identifierInput.value) identifierInput.value.focus() })
}

async function handleForgotPasswordSendCode() {
  debugger
  loadingSend.value = true;
  error.value = ''
  if (!forgotPasswordIdentifier.value.trim()) {
    error.value = 'لطفاً شماره موبایل یا نام کاربری را وارد کنید.'
    return
  }

  forgotPasswordStep.value = 2
  forgotPasswordCode.value = ''
  // nextTick(() => { if (codeInput.value) codeInput.value.focus() })
  try {
    const payload = {
      mobileNumber: forgotPasswordIdentifier.value
    }
    await authenticate.sendOtpForForgotPassword(payload);

  } catch (e) {
    // toast handled in store
  } finally {
    loadingSend.value = false;
    // forgotPasswordCode.value = true;
  }
}

function handleForgotPasswordCodeInput() {
  forgotPasswordCode.value = String(forgotPasswordCode.value || '').replace(/\D/g, '').slice(0, 6)
}

async function handleForgotPasswordVerify() {
  error.value = ''
  if (!/^\d{6}$/.test(forgotPasswordCode.value)) {
    error.value = 'کد باید 6 رقمی باشد'
    return
  }
  forgotPasswordStep.value = 3
  forgotPasswordNewPassword.value = ''
  forgotPasswordConfirmNewPassword.value = ''
  nextTick(() => { if (forgotPasswordNewPasswordInput.value) forgotPasswordNewPasswordInput.value.focus() })
}

async function handleForgotPasswordSetNewPassword() {
  error.value = ''
  const newPassword = forgotPasswordNewPassword.value.trim()
  const confirmNewPassword = forgotPasswordConfirmNewPassword.value.trim()

  if (!newPassword || !confirmNewPassword) {
    error.value = 'لطفا هر دو فیلد رمز عبور را وارد کنید.'
    return
  }

  if (newPassword.length < 6) {
    error.value = 'رمز عبور باید حداقل 6 کاراکتر باشد.'
    return
  }

  if (newPassword !== confirmNewPassword) {
    error.value = 'رمز عبور و تکرار آن یکسان نیستند.'
    return
  }

  forgotPasswordSubmitting.value = true
  try {
    const payload = {
      userName: forgotPasswordIdentifier.value,
      newPassword: newPassword,
      otpCode: forgotPasswordCode.value,

    }
    await authenticate.ChangeForgotPassword(payload);

  } catch (e) {
    // toast handled in store
  } finally {
    forgotPasswordSubmitting.value = false
    backToLoginFromForgot()
  }
}

async function handleRegister() {
  registerError.value = ''
  registerLoading.value = true;
  // بررسی خالی بودن فیلد
  if (!registerPhone.value.trim()) {
    registerError.value = 'لطفاً شماره موبایل را وارد کنید.'
    registerLoading.value = false;
    return
  }
  try {
    const base = (API_URL || '').replace(/\/$/, '')
    const response = await axios.get(`${base}/Authenticate/SendOtpForRegisterCustomer`, {
      params: {
        phoneNumber: registerPhone.value.trim()
      },
      headers: { 'Content-Type': 'application/json' }
    })

    console.log(response.data)
    const data = response.data || {}
    const raw = response.data
    const status = (data.status || data.Status || '').toString().toLowerCase()
    const message = data.message || data.Message || ''

    // اگر پاسخ خطا باشد، به مرحله ورود کد نرو (در همان مرحله فعلی بمان)
    const isErrorString = status === 'error'
    const isSuccess = status === 'success' || status === 'ok'
    if (!isSuccess || isErrorString) {
      registerError.value = message || 'خطا در ارسال کد'
      return
    }

    // فقط در صورت موفقیت، به مرحله 2 برو و تایمر/استوریج را تنظیم کن
    registerError.value = ''
    registerExpiryTimestamp.value = Date.now() + 180000
    registerResendAvailableAt.value = Date.now() + 60000
    localStorage.setItem('registerOtpExpiry', String(registerExpiryTimestamp.value))
    localStorage.setItem('registerPhone', String(registerPhone.value.trim()))
    localStorage.setItem('registerResendAt', String(registerResendAvailableAt.value))

    registerStep.value = 2
    startRegisterTimer()

    await nextTick()
    if (registerCodeInput.value) registerCodeInput.value.focus()
    return
  } catch (err) {
    // axios throws for non-2xx status codes; inspect err.response.data when available
    if (err && err.response && err.response.data) {
      try {
        const d = err.response.data
        registerError.value = d.message || JSON.stringify(d)
      } catch (e) {
        registerError.value = String(err)
      }
    } else {
      registerError.value = (err && err.message) || String(err) || 'خطا در ارسال'
    }
    // در صورت خطا، به مرحله ورود کد نرو
    return
  } finally { registerLoading.value = false; }
}

function startRegisterTimer() {
  clearRegisterTimer()
  registerNow.value = Date.now()
  registerTimerInterval = setInterval(() => {
    registerNow.value = Date.now()
    if (registerRemaining.value <= 0) clearRegisterTimer()
  }, 250)
}

function clearRegisterTimer() {
  if (registerTimerInterval) { clearInterval(registerTimerInterval); registerTimerInterval = null }
  registerExpiryTimestamp.value = registerExpiryTimestamp.value && registerRemaining.value > 0 ? registerExpiryTimestamp.value : null
}

async function handleRegisterVerify() {
  registerError.value = ''
  if (!/^\d{6}$/.test(registerCode.value)) { registerError.value = 'کد باید 6 رقمی باشد'; return }
  registerVerifyLoading.value = true
  try {
    // TODO: وصل به بک‌اند برای تایید کد ثبت نام
    const res = await verifyRegisterOtp(registerPhone.value.trim(), registerCode.value.trim())
    // شبیه‌سازی موقت
    await new Promise(resolve => setTimeout(resolve, 700))

    // موفقیت آمیز بود
    registerSuccess.value = 'ثبت نام با موفقیت انجام شد!'
    localStorage.removeItem('registerOtpExpiry')
    localStorage.removeItem('registerPhone')
    localStorage.removeItem('registerResendAt')
    clearRegisterTimer()

    // بعد از 2 ثانیه به تب لاگین برگرد
    setTimeout(() => {
      switchTab('login')
    }, 2000)
  } catch (err) {
    registerError.value = (err && err.message) || String(err) || 'خطا در تایید کد'
  } finally { registerVerifyLoading.value = false }
}

async function verifyRegisterOtp(registerPhone, registerCode) {
  // call backend VerifyOtp endpoint
  try {
    const resp = await axios.post(`${API_URL}/Authenticate/VerifyRegisterOtp`, {
      phoneNumber: registerPhone,
      otp: registerCode
    }, {
      headers: { 'Content-Type': 'application/json' }
    })

    const d = resp && resp.data ? resp.data : {}
    // backend may return token at top-level or inside data
    const token = d.token || (d.data && d.data.token) || null
    const companyInfo = d.companyInfo || (d.data && d.data.companyInfo) || null
    const storageInfo = d.storageInfo || (d.data && d.data.storageInfo) || null

    if (token) {
      localStorage.setItem('token', token)
      if (companyInfo) localStorage.setItem('companyInfo', JSON.stringify(companyInfo))
      if (storageInfo) localStorage.setItem('storageInfo', JSON.stringify(storageInfo))
      // default for OTP login
      localStorage.setItem('ismaster', 'false')

      // determine company activation status (mirror logic from loginPanel)
      const ci = companyInfo || JSON.parse(localStorage.getItem('companyInfo') || '{}')
      let isActive = false
      if (ci) {
        if (ci.companyisactive !== undefined) {
          isActive = ci.companyisactive === true || ci.companyisactive === 'true'
        } else if (ci.companyIsActive !== undefined) {
          isActive = ci.companyIsActive === true || ci.companyIsActive === 'true'
        } else if (ci.isActive !== undefined) {
          isActive = ci.isActive === true || ci.isActive === 'true'
        }
      }

      if (!isActive && (d.companyisactive !== undefined)) {
        isActive = d.companyisactive === true || d.companyisactive === 'true'
      }

      localStorage.setItem('companyisactive', isActive ? 'true' : 'false')

      // fetch app settings and then redirect accordingly
      try { await fetchSetting() } catch (e) { console.warn('fetchSetting failed', e) }

      if (isActive) {
        router.push('overview/clinic/clinic-dashboard')
      } else {
        router.push({ path: '/company-setup' })
      }

      // success
      if (toast && typeof toast.success === 'function') {
        toast.success('ورود با موفقیت انجام شد', { position: 'top-right', timeout: 1500 })
      }

      return { token }
    }

    throw new Error(d.message || d.Message || 'خطا در تایید کد')
  } catch (err) {
    // normalize axios errors
    if (err && err.response && (err.response.status === 401 || err.response.status === 400 || err.response.status === 500)) {
      const msg = (err.response.data && (err.response.data.message || JSON.stringify(err.response.data))) || 'خطا در اعتبارسنجی'
      throw new Error(msg)
    }
    throw err
  }
}

function resendRegisterOtp() {
  if (registerResendDisabled.value) return
  registerCode.value = ''
  handleRegister()
}

function backToRegisterStep1() {
  registerStep.value = 1
  registerCode.value = ''
  registerError.value = ''
  localStorage.removeItem('registerOtpExpiry')
  localStorage.removeItem('registerPhone')
  localStorage.removeItem('registerResendAt')
  clearRegisterTimer()
  nextTick(() => { if (registerInput.value) registerInput.value.focus() })
}

function handleRegisterOtpInput(e) {
  // فقط اعداد مجاز هستند
  e.target.value = e.target.value.replace(/\D/g, '')
  registerCode.value = e.target.value
}

function startTimer() {
  clearTimer()
  now.value = Date.now()
  timerInterval = setInterval(() => {
    now.value = Date.now()
    if (remaining.value <= 0) clearTimer()
  }, 250)
}

function clearTimer() {
  if (timerInterval) { clearInterval(timerInterval); timerInterval = null }
  expiryTimestamp.value = expiryTimestamp.value && remaining.value > 0 ? expiryTimestamp.value : null
}

function initTurnstile() {
  const tryRender = () => {
    if (!turnstileEl.value) return
    if (window.turnstile && typeof window.turnstile.render === 'function') {
      try {
        if (!SITE_KEY) { console.warn('TURNSTILE site key not set'); return }
        // NOTE: Turnstile no longer supports "invisible". Use a supported size and execute programmatically
        // to get the same UX (render small/flexible widget and call execute when needed).
        turnstileWidgetId.value = window.turnstile.render(turnstileEl.value, {
          sitekey: SITE_KEY,
          // use 'flexible' to adapt to available space; we call execute() when sending to mimic invisible flow
          size: 'flexible',
          action: 'otp_send',
          callback: (token) => {
            // received token from Turnstile
            try { if (turnstileTimeoutId) { clearTimeout(turnstileTimeoutId); turnstileTimeoutId = null } } catch (e) { console.warn(e) }
            turnstileToken.value = token
            turnstileTokenExpiry.value = Date.now() + 120000
            if (awaitingTurnstile.value) { awaitingTurnstile.value = false; doSend() }
          }
        })
      } catch (e) { console.warn('turnstile render failed', e) }
    } else { setTimeout(tryRender, 250) }
  }
  tryRender()
}



// ارسال OTP با کپچا (غیرفعال)
async function doSend() {
  error.value = ''
  loadingSend.value = true
  try {
    if (!turnstileToken.value || Date.now() > turnstileTokenExpiry.value) {
      error.value = 'لطفاً کپچا را کامل کنید.'
      try { if (window.turnstile && turnstileWidgetId.value !== null) window.turnstile.reset(turnstileWidgetId.value) } catch (e) { console.warn(e) }
      return
    }

    const payload = { identifier: identifier.value.trim(), turnstileToken: turnstileToken.value }
    const resp = await apiClient.post('/api/otp/send', payload)
    const data = resp && resp.data ? resp.data : {}
    // تایمر 3 دقیقه (180 ثانیه)
    expiryTimestamp.value = data.expiry || (Date.now() + 180000)
    resendAvailableAt.value = Date.now() + 60000
    localStorage.setItem('otpExpiry', String(expiryTimestamp.value))
    localStorage.setItem('otpIdentifier', String(identifier.value.trim()))
    localStorage.setItem('otpResendAt', String(resendAvailableAt.value))
    step.value = 2
    startTimer()
    await nextTick()
    if (codeInput.value) codeInput.value.focus()
    // فعال کردن WebOTP API برای خواندن خودکار کد
    requestWebOTP()
    try { if (window.turnstile && turnstileWidgetId.value !== null) window.turnstile.reset(turnstileWidgetId.value) } catch (e) { console.warn(e) }
    turnstileToken.value = ''
    turnstileTokenExpiry.value = 0
  } catch (err) {
    if (err && err.response && err.response.status === 403) {
      error.value = (err.response.data && err.response.data.message) || 'تأیید کپچا انجام نشد. دوباره تلاش کنید.'
    } else {
      error.value = (err && err.message) || String(err) || 'خطا در ارسال کد'
    }
    try { if (window.turnstile && turnstileWidgetId.value !== null) window.turnstile.reset(turnstileWidgetId.value) } catch (e) { console.warn(e) }
    turnstileToken.value = ''
    turnstileTokenExpiry.value = 0
  } finally { loadingSend.value = false }
}

error.value = ''
async function handleSend() {

  error.value = ''

  // بررسی خالی بودن فیلد
  if (!identifier.value.trim()) {
    error.value = 'لطفاً ایمیل یا شماره موبایل را وارد کنید.'
    return
  }

  // رمز عبور اجباری است برای ارسال OTP (از بازگشت 400 جلوگیری می‌کند)
  if (!password.value.trim()) {
    error.value = 'لطفاً رمز عبور را وارد کنید.'
    return
  }

  loadingSend.value = true
  // تماس به بک‌اند و هندل کردن پاسخ / خطا
  try {
    const response = await axios.post(`${API_URL}/Authenticate/SendOtp`, {
      username: identifier.value.trim(),
      password: password.value.trim()
    }, {
      headers: { 'Content-Type': 'application/json' }
    })
    console.log(response.data)
    const data = response.data || {}
    const raw = response.data
    const status = (data.status || data.Status || '').toString().toLowerCase()
    const message = data.message || data.Message || ''

    // اگر پاسخ خطا باشد، به مرحله ورود کد نرو
    const isErrorString = status === 'error'
    const isSuccess = status === 'success' || status === 'ok'
    if (!isSuccess || isErrorString) {
      error.value = message || 'خطا در ارسال کد'
      return
    }

    // فقط در صورت موفقیت، به مرحله 2 برو و تایمر/استوریج را تنظیم کن
    expiryTimestamp.value = Date.now() + 180000
    resendAvailableAt.value = Date.now() + 60000
    localStorage.setItem('otpExpiry', String(expiryTimestamp.value))
    localStorage.setItem('otpIdentifier', String(identifier.value.trim()))
    localStorage.setItem('otpResendAt', String(resendAvailableAt.value))

    step.value = 2
    startTimer()

    await nextTick()
    if (codeInput.value) codeInput.value.focus()
  } catch (err) {
    // axios throws for non-2xx status codes; inspect err.response.data when available
    if (err && err.response && err.response.data) {
      try {
        const d = err.response.data
        error.value = d.message || JSON.stringify(d)
      } catch (e) {
        error.value = String(err)
      }
    } else {
      error.value = (err && err.message) || String(err) || 'خطا در ارسال'
    }
    // در صورت خطا، به مرحله ورود کد نرو
  } finally {
    loadingSend.value = false
  }

  // فعال کردن WebOTP API برای خواندن خودکار کد
  //requestWebOTP()
}

async function handleVerify() {
  error.value = ''
  if (!/^\d{6}$/.test(code.value)) { error.value = 'کد باید 6 رقمی باشد'; return }
  loadingVerify.value = true
  try {
    const res = await verifyOtp(identifier.value.trim(), code.value.trim())
    // on success verifyOtp performs storage & navigation
    if (res && res.token) {
      localStorage.removeItem('otpExpiry')
      localStorage.removeItem('otpIdentifier')
      localStorage.removeItem('otpResendAt')
      clearTimer()
    }
  } catch (err) {
    error.value = (err && err.message) || String(err) || 'خطا در تایید کد'
  } finally { loadingVerify.value = false }
}

async function verifyOtp(identifierParam, codeParam) {
  // call backend VerifyOtp endpoint
  try {
    const resp = await axios.post(`${API_URL}/Authenticate/VerifyOtp`, {
      username: identifierParam,
      otpCode: codeParam
    }, {
      headers: { 'Content-Type': 'application/json' }
    })

    const d = resp && resp.data ? resp.data : {}
    // backend may return token at top-level or inside data
    const token = d.token || (d.data && d.data.token) || null
    const companyInfo = d.companyInfo || (d.data && d.data.companyInfo) || null
    const storageInfo = d.storageInfo || (d.data && d.data.storageInfo) || null

    if (token) {
      localStorage.setItem('token', token)
      if (companyInfo) localStorage.setItem('companyInfo', JSON.stringify(companyInfo))
      if (storageInfo) localStorage.setItem('storageInfo', JSON.stringify(storageInfo))
      // default for OTP login
      localStorage.setItem('ismaster', 'false')

      // determine company activation status (mirror logic from loginPanel)
      const ci = companyInfo || JSON.parse(localStorage.getItem('companyInfo') || '{}')
      let isActive = false
      if (ci) {
        if (ci.companyisactive !== undefined) {
          isActive = ci.companyisactive === true || ci.companyisactive === 'true'
        } else if (ci.companyIsActive !== undefined) {
          isActive = ci.companyIsActive === true || ci.companyIsActive === 'true'
        } else if (ci.isActive !== undefined) {
          isActive = ci.isActive === true || ci.isActive === 'true'
        }
      }

      if (!isActive && (d.companyisactive !== undefined)) {
        isActive = d.companyisactive === true || d.companyisactive === 'true'
      }

      localStorage.setItem('companyisactive', isActive ? 'true' : 'false')

      // fetch app settings and then redirect accordingly
      try { await fetchSetting() } catch (e) { console.warn('fetchSetting failed', e) }

      if (isActive) {
        router.push('overview/clinic/clinic-dashboard')
      } else {
        router.push({ path: '/company-setup' })
      }

      // success
      if (toast && typeof toast.success === 'function') {
        toast.success('ورود با موفقیت انجام شد', { position: 'top-right', timeout: 1500 })
      }

      return { token }
    }

    throw new Error(d.message || d.Message || 'خطا در تایید کد')
  } catch (err) {
    // normalize axios errors
    if (err && err.response && (err.response.status === 401 || err.response.status === 400 || err.response.status === 500)) {
      const msg = (err.response.data && (err.response.data.message || JSON.stringify(err.response.data))) || 'خطا در اعتبارسنجی'
      throw new Error(msg)
    }
    throw err
  }
}

function resendOtp() {
  if (resendDisabled.value) return

  // اگر کد منقضی شده است، نیاز است کاربر مجدداً شناسه/رمز را وارد کند
  if (expired.value) {
    error.value = 'کد منقضی شده است. لطفاً شماره/ایمیل و رمز عبور را مجدداً وارد کنید.'
    backToStep1()
    nextTick(() => { if (passwordInput.value) passwordInput.value.focus() })
    return
  }

  code.value = ''
  handleSend()
}

function backToStep1() {
  step.value = 1
  forgotPasswordMode.value = false
  forgotPasswordStep.value = 1
  forgotPasswordCode.value = ''
  forgotPasswordNewPassword.value = ''
  forgotPasswordConfirmNewPassword.value = ''
  forgotPasswordSubmitting.value = false
  code.value = ''
  error.value = ''
  localStorage.removeItem('otpExpiry')
  localStorage.removeItem('otpIdentifier')
  localStorage.removeItem('otpResendAt')
  clearTimer()
  cancelWebOTP()
  nextTick(() => { if (identifierInput.value) identifierInput.value.focus() })
}

// WebOTP API برای خواندن خودکار کد از SMS
let abortController = null
const API_URL = process.env.VUE_APP_BACKEND_URL;

async function requestWebOTP() {
  // بررسی پشتیبانی از WebOTP API
  if (!('OTPCredential' in window)) {
    console.log('WebOTP API پشتیبانی نمی‌شود')
    return
  }

  try {
    cancelWebOTP()
    abortController = new AbortController()

    navigator.credentials.get({
      otp: { transport: ['sms'] },
      signal: abortController.signal
    })
      .then(otp => {
        if (otp && otp.code) {
          code.value = otp.code
          // خودکار تایید کد
          if (/^\d{6}$/.test(otp.code)) {
            nextTick(() => handleVerify())
          }
        }
      })
      .catch(err => {
        if (err.name !== 'AbortError') {
          console.warn('خطا در خواندن OTP:', err)
        }
      })
  } catch (err) {
    console.warn('خطا در فعال‌سازی WebOTP:', err)
  }
}

function cancelWebOTP() {
  if (abortController) {
    try {
      abortController.abort()
    } catch (e) {
      console.warn('خطا در لغو WebOTP:', e)
    }
    abortController = null
  }
}

function handleOtpInput() {
  // خودکار تایید کد وقتی 6 رقم وارد شد
  if (/^\d{6}$/.test(code.value)) {
    nextTick(() => handleVerify())
  }
}

function onGoogle() {
  if (googleLoading.value) return
  error.value = ''
  googleLoading.value = true

  // open OAuth popup to backend which should handle Google OAuth flow and then
  // postMessage back to window.opener with { type: 'oauth', provider: 'google', token }
  try {
    googleWindow = window.open('/auth/google', 'google_auth', 'width=600,height=700')
  } catch (e) {
    googleWindow = null
  }

  if (!googleWindow) {
    error.value = 'مرورگر مانع باز شدن پنجره ورود شد. لطفاً اجازهٔ باز شدن پنجره‌ها را بدهید.'
    googleLoading.value = false
    return
  }

  // message handler to receive token from popup
  _onGoogleMessage = function (ev) {
    try {
      if (!ev || ev.origin !== window.location.origin) return
      const d = ev.data || {}
      if (d.type !== 'oauth' || d.provider !== 'google') return
      // close popup and finalize
      try { if (googleWindow && !googleWindow.closed) googleWindow.close() } catch (e) { /* ignore */ }
      if (d.error) {
        error.value = d.error || 'خطا در ورود با گوگل'
        googleLoading.value = false
        return
      }
      if (d.token) {
        localStorage.setItem('token', d.token)
        // cleanup and redirect
        googleLoading.value = false
        window.location.href = '/'
      }
    } catch (e) { console.warn(e); googleLoading.value = false }
  }

  window.addEventListener('message', _onGoogleMessage)

  // poll popup to detect closure without a message
  googleInterval = setInterval(() => {
    try {
      // detect popup closed
      if (!googleWindow || googleWindow.closed) {
        clearInterval(googleInterval); googleInterval = null
        window.removeEventListener('message', _onGoogleMessage); _onGoogleMessage = null
        if (googleLoading.value) {
          googleLoading.value = false
          error.value = 'ورود با گوگل انجام نشد.'
        }
        return
      }

      // also check if backend set token in localStorage (fallback when popup doesn't postMessage)
      try {
        const t = localStorage.getItem('token')
        if (t) {
          clearInterval(googleInterval); googleInterval = null
          window.removeEventListener('message', _onGoogleMessage); _onGoogleMessage = null
          googleLoading.value = false
          window.location.href = '/'
        }
      } catch (e) { /* ignore */ }
    } catch (e) { console.warn(e) }
  }, 500)
}

// Global error handlers to surface better messages and capture rejections
function _onWindowError(ev) {
  try { console.error('window.error', ev); error.value = (ev && (ev.message || String(ev.error || ev))) || 'خطای غیرمنتظره' } catch (e) { console.error(e) }
}
function _onUnhandledRejection(ev) {
  try {
    console.error('unhandledrejection', ev && ev.reason)
    const r = ev && ev.reason
    error.value = r && (r.message || (typeof r === 'string' ? r : JSON.stringify(r))) || String(r)
    if (ev && typeof ev.preventDefault === 'function') ev.preventDefault()
  } catch (e) { console.error(e) }
}

onMounted(() => {
  // resume timer if present
  try {
    const storedExpiry = Number(localStorage.getItem('otpExpiry') || 0)
    const storedIdentifier = localStorage.getItem('otpIdentifier') || ''
    const storedResend = Number(localStorage.getItem('otpResendAt') || 0)
    if (storedExpiry && storedExpiry > Date.now() && storedIdentifier) {
      identifier.value = storedIdentifier
      expiryTimestamp.value = storedExpiry
      resendAvailableAt.value = storedResend || (Date.now() + 60000)
      step.value = 2
      startTimer()
      nextTick(() => {
        if (codeInput.value) codeInput.value.focus()
        requestWebOTP()
      })
    }
  } catch (e) { console.warn(e) }

  initTurnstile()
  // listen for runtime errors and prevent the dev-server overlay when possible
  window.addEventListener('error', _onWindowError)
  // assign window.onerror to capture more contextual params and suppress default overlay
  try {
    window.__prevOnError = window.onerror
    window.onerror = function (message, source, lineno, colno, err) {
      try {
        console.error('window.onerror', { message, source, lineno, colno, err })
        // prefer human-friendly message when details are absent (cross-origin script errors show 'Script error.')
        if (message === 'Script error.' && !err) {
          error.value = 'خطای اسکریپت خارجی رخ داده است. جزئیات را در کنسول بررسی کنید.'
        } else {
          error.value = (err && err.message) || message || String(err) || 'خطای غیرمنتظره'
        }
      } catch (e) { console.error(e) }
      try { if (typeof event !== 'undefined' && event && typeof event.preventDefault === 'function') event.preventDefault() } catch (e) { console.warn(e) }
      // return true to indicate we've handled the error and prevent the default handler (dev overlay)
      return true
    }
  } catch (e) { console.warn(e) }
  window.addEventListener('unhandledrejection', _onUnhandledRejection)
})

onBeforeUnmount(() => {
  clearTimer()
  clearRegisterTimer()
  cancelWebOTP()
  try { if (window.turnstile && turnstileWidgetId.value !== null) window.turnstile.reset(turnstileWidgetId.value) } catch (e) { console.warn(e) }
  try { window.removeEventListener('error', _onWindowError) } catch (e) { /* ignore */ }
  try { window.removeEventListener('unhandledrejection', _onUnhandledRejection) } catch (e) { /* ignore */ }
  try { if (window.__prevOnError !== undefined) { window.onerror = window.__prevOnError; delete window.__prevOnError } } catch (e) { /* ignore */ }
  try {
    if (_onGoogleMessage) { window.removeEventListener('message', _onGoogleMessage); _onGoogleMessage = null }
  } catch (e) { /* ignore */ }
  try { if (googleInterval) { clearInterval(googleInterval); googleInterval = null } } catch (e) { /* ignore */ }
  try { if (googleWindow && !googleWindow.closed) { googleWindow.close(); googleWindow = null } } catch (e) { /* ignore */ }
})
</script>

<style scoped>
.login-page3 {
  display: flex;
  min-height: 100vh;
  direction: rtl;
  font-family: "IRANSans", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
  background: #f5f7f8;
  position: relative;
  /* allow absolute-positioned back button */
  align-items: stretch;
}

.hero {
  flex: 1 1 60%;
  /* gradient background using requested colors */
  background: linear-gradient(180deg, #f2f3f4 0%, #d7d8d8 100%);
  color: #1c3f79;
  /* dark text on light background */
  display: flex;
  flex-direction: column;
  /* center hero content horizontally and vertically */
  direction: rtl;
  /* keep text flow Persian-friendly */
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.hero-inner {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* nudge the hero content 40px to the left from true center */
  transform: translateX(-40px);
}

.logo-wrap {
  position: relative;
  width: 100%;
  max-width: clamp(260px, 45vw, 680px);
  /* flexible width that grows/shrinks */
  height: auto;
  display: flex;
  flex-direction: column;
  /* stack image and + vertically so + won't overlay the image */
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.plane {
  width: 100%;
  height: auto;
  max-width: 100%;
  display: block;
  object-fit: contain;
  filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.08));
}

.hero-text {
  text-align: center;
  margin-top: clamp(12px, 3vw, 40px);
  width: 100%;
  max-width: clamp(260px, 45vw, 600px);
}

.hero-text h1 {
  font-size: clamp(1.15rem, 2.2vw, 2.2rem);
  margin: 0px 0px 20px 0px;
  font-weight: 700;
  line-height: 1.7;
}

.hero-text h2 {
  font-size: clamp(0.95rem, 2.2vw, 1.25rem);
  margin: 6px 0 18px;
  opacity: 0.95;
}


.cta:hover,
.cta:focus {
  transform: translateY(-3px) scale(1.01);
  box-shadow: 0 14px 40px rgba(15, 95, 209, 0.18), 0 6px 18px rgba(0, 0, 0, 0.06);
  background-color: #0f5fd1;
  /* hover color */
  opacity: 1;
}

.cta:active {
  transform: translateY(-1px) scale(0.995);
  box-shadow: 0 6px 18px rgba(12, 79, 176, 0.16);
  background-color: #0c4fb0;
  /* active/pressed color */
}

.cta:focus-visible {
  outline: 3px solid rgba(20, 116, 242, 0.18);
  outline-offset: 4px;
}

.auth-card {
  width: clamp(300px, 32vw, 420px);
  max-width: 420px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 32px;
  /* place auth card above the hero background on wide screens */
  position: absolute;
  right: clamp(12px, 4vw, 64px);
  top: 50%;
  transform: translateY(-50%);
  z-index: 20;
}

.card-inner {
  width: 100%;
  background: #fff;
  border-radius: 14px;
  padding: 28px 28px 20px;
  box-shadow: 0 8px 40px rgba(18, 38, 49, 0.06);
  position: relative;
}

.lang {
  position: absolute;
  top: 12px;
  left: 12px;
  background: transparent;
  font-weight: 600;
  color: #6b6f73;
}

.card-title {
  color: #1474f2;
  /* use bright blue for heading */
  text-align: center;
  margin-top: 6px;
  margin-bottom: 16px;
  /* larger, responsive heading for login card */
  font-size: clamp(1.05rem, 2.2vw, 1.5rem);
  font-weight: 800;
}

.card-tabs {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-bottom: 12px
}

.form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.tab-enter-active,
.tab-leave-active {
  transition: opacity 240ms cubic-bezier(.2, .9, .2, 1), transform 240ms cubic-bezier(.2, .9, .2, 1);
}

.tab-enter-from {
  opacity: 0;
  transform: translateX(10px);
}

.tab-enter-to {
  opacity: 1;
  transform: translateX(0);
}

.tab-leave-from {
  opacity: 1;
  transform: translateX(0);
}

.tab-leave-to {
  opacity: 0;
  transform: translateX(-10px);
}

.forgot-flow-enter-active,
.forgot-flow-leave-active,
.forgot-step-enter-active,
.forgot-step-leave-active {
  transition: opacity 220ms ease, transform 220ms ease;
}

.forgot-flow-enter-from,
.forgot-step-enter-from {
  opacity: 0;
  transform: translateY(8px);
}

.forgot-flow-leave-to,
.forgot-step-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

@media (prefers-reduced-motion: reduce) {

  .tab-enter-active,
  .tab-leave-active {
    transition: none;
  }

  .forgot-flow-enter-active,
  .forgot-flow-leave-active,
  .forgot-step-enter-active,
  .forgot-step-leave-active {
    transition: none;
  }
}

.input {
  height: 40px;
  border-radius: 6px;
  border: 1px solid #e6edf0;
  padding: 6px 12px;
  outline: none;
}

.password-input {
  margin-top: 16px;
}

.links {
  font-size: 12px;
  color: #6f7476;
  margin-top: 10px;
  line-height: 1.6;
  text-align: center;
}

.divider {
  text-align: center;
  margin: 30px 0;
  color: #bfc7c8;
}

.center-btn {
  display: flex;
  justify-content: center;
}

.g-icon {
  vertical-align: middle;
  width: 20px;
  height: 20px;
  display: block;
  object-fit: contain;
}

.terms {
  font-size: 12px;
  color: #9aa4a6;
  text-align: center;
  margin-top: 12px;
}

.terms a {
  color: #1474f2;
  text-decoration: underline
}

.field-label {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
  color: #263a4f;
}

.otp-step .input {
  width: 100%;
}

.register-step .input {
  width: 100%;
}

.otp-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px
}

.timer {
  color: #6b6f73;
  font-size: 13px;
  font-weight: 600
}

.timer-warning {
  color: #e67e22;
  animation: pulse 1.5s ease-in-out infinite
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1
  }

  50% {
    opacity: 0.7
  }
}

.otp-actions {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-top: 12px
}

.forgot-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
}

.forgot-reset-step {
  display: flex;
  flex-direction: column;
}

.forgot-reset-title {
  font-size: 20px;
  font-weight: 700;
  color: #263a4f;
  margin: 0 0 8px;
  text-align: center;
}

.forgot-reset-text {
  font-size: 13px;
  color: #6f7476;
  margin: 0 0 12px;
  line-height: 1.8;
  text-align: center;
}

.otp-secondary {
  margin-top: 12px;
  display: flex;
  justify-content: center
}

.error {
  color: #c0392b;
  margin-top: 10px;
  text-align: center
}

.back-site {
  position: absolute;
  top: 18px;
  right: 18px;
  background: rgba(255, 255, 255, 0.95);
  color: #9aa2ac;
  /* neutral gray per request */
  padding: 8px 14px;
  border-radius: 20px;
  font-weight: 700;
  box-shadow: 0 6px 18px rgba(30, 60, 70, 0.06);
  z-index: 30;
  /* make sure it appears above hero/auth-card */
  text-decoration: none;
}

.back-site:hover {
  opacity: 0.95
}

/* Responsive: on narrow screens stack card below hero and make hero flexible */
@media (max-width:900px) {
  .login-page3 {
    flex-direction: column
  }

  /* keep auth card a comfortable size on tablet rather than full-width */
  .auth-card {
    width: min(420px, 92%);
    padding: 22px;
    position: static !important;
    transform: none;
    max-width: 420px;
    margin: 50px auto 40px
  }

  /* hide hero on tablet and smaller so auth-card is the focus */
  .hero {
    display: none
  }

  .logo-wrap {
    max-width: 60%;
  }

  .hero-text {
    max-width: 95%;
    margin-top: 20px
  }

  .hero-text h1 {
    font-size: clamp(1rem, 5vw, 1.5rem)
  }

  /* reduce the left nudge on narrower viewports so layout feels balanced */
  .hero-inner {
    transform: translateX(-20px)
  }
}

/* On mobile (phones) hide the hero to focus on the auth card */
@media (max-width:600px) {
  .hero {
    display: none
  }

  /* ensure layout stacks cleanly when hero is hidden */
  .login-page3 {
    flex-direction: column
  }

  /* limit width on phones too so the card has comfortable side margins */
  .auth-card {
    width: min(420px, 92%);
    padding: 18px;
    position: static !important;
    transform: none;
    max-width: 420px;
    margin: 50px auto 28px
  }
}
</style>
